import { FiAlertCircle } from "react-icons/fi";
import { BrandPanel } from "./AuthLayout";
import { AUTH_FEATURES, AUTH_PANEL_IMAGE } from "./ImageComponent";

export const TerminateImageComponent = () => {
  return (
    <BrandPanel
      showOnMobile
      tone="warning"
      statusIcon={FiAlertCircle}
      eyebrow="Survey ended"
      title="Almost, but not quite!"
      description={`This one wasn't a match based on your profile — but there are plenty more waiting. Find your next survey and start earning.`}
      features={AUTH_FEATURES}
      image={AUTH_PANEL_IMAGE}
      imageAlt="People taking part in surveys"
    />
  );
};
